import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';
import { PermissionsGuard } from './guards/permissions.guard';
import { ProiecteComponent } from './layout/nomenclatoare/proiecte/proiecte.component';
import { SetariProiecteComponent } from './layout/nomenclatoare/setari-proiecte/setari-proiecte.component';
import { AccesInterzisComponent } from './components/acces-interzis/acces-interzis.component';
import { ProiectePushNotificationsComponent } from './layout/nomenclatoare/proiecte-push-notifications/proiecte-push-notifications.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'proiecte',
        pathMatch: 'full',
    },
    {
        path: 'access-denied',
        component: AccesInterzisComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'proiecte',
                component: ProiecteComponent,
            },
            {
                path: 'push-notifications-proiecte',
                component: ProiectePushNotificationsComponent,
            },
            {
                path: 'setari-proiecte',
                component: SetariProiecteComponent,
            },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: 'setari-proiecte',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
